var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgNotification = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M4.688 9.843V6.582c0-2.496 1.93-4.52 4.312-4.52 2.381 0 4.313 2.024 4.313 4.52v3.261l1.124 2.043v2.358H3.563v-2.358zm6.562 4.401A2.25 2.25 0 0 1 9 16.494a2.25 2.25 0 0 1-2.25-2.25" }) }))); };
export default SvgNotification;
